import React, { useCallback, useMemo, useState } from 'react';
import cn from 'classnames/bind';
import styles from './styles.styl';
import { Select } from '@consta/uikit/Select';
import { Text } from '@consta/uikit/Text';
import { IconDraggable } from '@consta/uikit/IconDraggable';
import { IUserInit } from 'src/redux/features/userInit/types';
import { DroppableUserEnum, InitRoleEnum } from 'src/utils/enum';
import { allRole } from 'src/utils/config';
import { Checkbox } from '@consta/uikit/Checkbox';
import { Badge } from '@consta/uikit/Badge';
import { Button } from '@consta/uikit/Button';
import {
  DragDropContext,
  DropResult,
  Droppable,
  Draggable,
} from 'react-beautiful-dnd';
import { IAllUsersDataEnt } from 'src/redux/features/users/allUsers/types';

const cx = cn.bind(styles);

export interface IUserAddModalProps {
  userInit: IUserInit;
  allUsers: IAllUsersDataEnt[];
  userModelData: IAllUsersDataEnt[];
  setUserModelData: React.Dispatch<React.SetStateAction<IAllUsersDataEnt[]>>;
}

export interface ItemChecked {
  [id: string]: IAllUsersDataEnt;
}

const UserAddModal: React.FC<IUserAddModalProps> = ({
  userInit,
  allUsers,
  userModelData,
  setUserModelData,
}) => {
  const newInit = [...userInit.roles];
  newInit.unshift(allRole);

  const newAllUser = allUsers.filter(
    (item) => !userModelData.some((data) => data.id === item.id),
  );

  const [roleType, setRoleType] = useState(
    newInit.find((item) => item.key === InitRoleEnum.ALL_ROLE),
  );

  const [allUserData, setAllUserData] = useState(newAllUser);
  const [checkedAllUser, setCheckedAllUser] = useState<ItemChecked>({});
  const [checkedUserModel, setCheckedUserModel] = useState<ItemChecked>({});

  const nameRole = useCallback((id: string) => {
    return newInit.find((item) => item.key === id)?.name;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCheckedAllUser = useCallback(
    (data) => {
      if (checkedAllUser[data.id]) {
        const newChecked = { ...checkedAllUser };
        delete newChecked[data.id];
        setCheckedAllUser(newChecked);
      } else {
        setCheckedAllUser({ ...checkedAllUser, [data.id]: data });
        setCheckedUserModel({});
      }
    },
    [checkedAllUser],
  );

  const handleCheckedUserModel = useCallback(
    (data) => {
      if (checkedUserModel[data.id]) {
        const newChecked = { ...checkedUserModel };
        delete newChecked[data.id];
        setCheckedUserModel(newChecked);
      } else {
        setCheckedUserModel({ ...checkedUserModel, [data.id]: data });
        setCheckedAllUser({});
      }
    },
    [checkedUserModel],
  );

  const handleAccess = useCallback(
    (isAllUser: boolean) => {
      if (isAllUser) {
        const newIdValue = Object.values(checkedAllUser);
        setAllUserData((prev) =>
          prev.filter((item) => !newIdValue.includes(item)),
        );
        setUserModelData([...userModelData, ...newIdValue]);
        setCheckedAllUser({});
      } else {
        const newIdValue = Object.values(checkedUserModel);
        setUserModelData((prev: IAllUsersDataEnt[]) =>
          prev.filter((item: IAllUsersDataEnt) => !newIdValue.includes(item)),
        );
        setAllUserData([...allUserData, ...newIdValue]);
        setCheckedUserModel({});
      }
    },
    [
      allUserData,
      checkedAllUser,
      checkedUserModel,
      setUserModelData,
      userModelData,
    ],
  );

  const allUserFilter = useMemo(() => {
    if (roleType.key === InitRoleEnum.ALL_ROLE) {
      return allUserData;
    } else {
      return allUserData.filter((item) => item.role_name === roleType.key);
    }
  }, [allUserData, roleType]);

  const onDragEnd = (result: DropResult) => {
    const { destination, source, draggableId } = result;

    if (!destination || destination.droppableId === source.droppableId) {
      return;
    }

    const newAllUser = [...allUserData];
    const newUserModelData = [...userModelData];
    const newIndexAllUser = newAllUser.findIndex(
      (item) => item.id === draggableId,
    );
    let add;
    if (source.droppableId === DroppableUserEnum.MODELS_USER) {
      add = newUserModelData[source.index];
      newUserModelData.splice(source.index, 1);
      const newChecked = { ...checkedUserModel };
      delete newChecked[draggableId];
      setCheckedUserModel(newChecked);
    } else {
      add = newAllUser[newIndexAllUser];
      newAllUser.splice(newIndexAllUser, 1);
      const newChecked = { ...checkedAllUser };
      delete newChecked[draggableId];
      setCheckedAllUser(newChecked);
    }

    if (destination.droppableId === DroppableUserEnum.MODELS_USER) {
      newUserModelData.splice(destination.index, 0, add);
    } else {
      newAllUser.splice(destination.index, 0, add);
    }

    setAllUserData(newAllUser);
    setUserModelData(newUserModelData);
  };
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className={cx('UserAddModal')}>
        {(Object.keys(checkedAllUser).length > 0 ||
          Object.keys(checkedUserModel).length > 0) && (
          <div className={cx('UserAddModal__choseContent')}>
            <Text size="s" className={cx('UserAddModal__chose')}>
              Выбрано сотрудников:
            </Text>
            <Text size="s" className={cx('UserAddModal__choseNumber')}>
              {Object.keys(checkedAllUser).length > 0
                ? Object.keys(checkedAllUser).length
                : Object.keys(checkedUserModel).length}
            </Text>
            <Button
              label={
                Object.keys(checkedAllUser).length > 0
                  ? 'Разрешить доступ'
                  : 'Запретить доступ'
              }
              size={'s'}
              view="ghost"
              onClick={() =>
                handleAccess(Object.keys(checkedAllUser).length > 0)
              }
            />
          </div>
        )}
        <div className={cx('UserAddModal__contentGrid')}>
          <Droppable droppableId={DroppableUserEnum.MODELS_USER}>
            {(provided) => (
              <div className={cx('UserAddModal__columnMobile')}>
                <div className={cx('UserAddModal__titleDiv')}>
                  <Text
                    size="s"
                    view="secondary"
                    className={cx('UserAddModal__title')}
                  >
                    Есть доступ к модели
                  </Text>
                </div>
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  className={cx('UserAddModal__providContainer')}
                >
                  {userModelData.map((item, index) => (
                    <Draggable
                      key={item.id}
                      draggableId={item.id}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                        >
                          <div className={cx('UserAddModal__containerUser')}>
                            <IconDraggable
                              className={cx('UserAddModal__draggableIcon')}
                              {...provided.dragHandleProps}
                            />
                            <Checkbox
                              className={cx('UserAddModal__checkbox')}
                              view="primary"
                              onClick={() => handleCheckedUserModel(item)}
                              checked={!!checkedUserModel[item.id]}
                            />
                            <Text
                              size="s"
                              className={cx('UserAddModal__nameUser')}
                            >
                              {item.username}
                            </Text>
                            <Badge
                              size="s"
                              view="stroked"
                              label={nameRole(item.role_name)}
                            />
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                </div>
                {provided.placeholder}
              </div>
            )}
          </Droppable>
          <Droppable droppableId={DroppableUserEnum.ALL_USER}>
            {(provided) => (
              <div className={cx('UserAddModal__columnMobile1')}>
                <div className={cx('UserAddModal__titleDivAll')}>
                  <Text
                    size="s"
                    view="secondary"
                    className={cx('UserAddModal__title')}
                  >
                    Все пользователи
                  </Text>
                  <div className={cx('UserAddModal__selectDiv')}>
                    <Select
                      className={cx('UserAddModal__select')}
                      onChange={({ value }) => {
                        setRoleType(value);
                        setCheckedAllUser({});
                      }}
                      id="typeField"
                      items={newInit}
                      value={roleType}
                      getItemLabel={(item) => item.name}
                      getItemKey={(item) => item.key}
                      size="s"
                    />
                  </div>
                </div>
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  className={cx('UserAddModal__providContainer')}
                >
                  {allUserFilter.map((item, index) => (
                    <Draggable
                      key={item.id}
                      draggableId={item.id}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                        >
                          <div
                            className={cx('UserAddModal__containerUser')}
                            key={item.id}
                          >
                            <IconDraggable
                              className={cx('UserAddModal__draggableIcon')}
                              {...provided.dragHandleProps}
                            />
                            <Checkbox
                              className={cx('UserAddModal__checkbox')}
                              view="primary"
                              onChange={() => handleCheckedAllUser(item)}
                              checked={!!checkedAllUser[item.id]}
                            />
                            <Text
                              size="s"
                              className={cx('UserAddModal__nameUser')}
                            >
                              {item.username}
                            </Text>
                            <Badge
                              size="s"
                              view="stroked"
                              label={nameRole(item.role_name)}
                            />
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              </div>
            )}
          </Droppable>
        </div>
      </div>
    </DragDropContext>
  );
};

export default UserAddModal;
